// src/stores/kpi/KPIReducer.js
import { createSlice } from '@reduxjs/toolkit';
import {
  defectRateThunk,
  deliveryComplianceRateThunk,
  operationRateThunk,
  productionByProductThunk,
  readTimeThunk,
  deliveryComplianceThunk,
  materialStockPriceThunk,
  operationTimeThunk,
} from './KPIThunks';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const kpiSlice = createSlice({
  name: 'kpi',
  initialState,
  reducers: {

    funGetPercentage(state, action) { state.data = action.payload; },
    funGetTimeSeries(state, action) { state.data = action.payload; },
  },
  extraReducers: (builder) => {
    const pend = (state) => { state.loading = true; state.error = null; };
    const ok = (state, action) => { state.loading = false; state.data = action.payload ?? null; };
    const fail = (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error?.message || 'KPI 조회 실패';
    };

    builder
      .addCase(defectRateThunk.pending, pend)
      .addCase(defectRateThunk.fulfilled, ok)
      .addCase(defectRateThunk.rejected, fail)

      .addCase(deliveryComplianceRateThunk.pending, pend)
      .addCase(deliveryComplianceRateThunk.fulfilled, ok)
      .addCase(deliveryComplianceRateThunk.rejected, fail)

      .addCase(operationRateThunk.pending, pend)
      .addCase(operationRateThunk.fulfilled, ok)
      .addCase(operationRateThunk.rejected, fail)
      .addCase(productionByProductThunk.pending, pend)
      .addCase(productionByProductThunk.fulfilled, ok)
      .addCase(productionByProductThunk.rejected, fail)

      .addCase(readTimeThunk.pending, pend)
      .addCase(readTimeThunk.fulfilled, ok)
      .addCase(readTimeThunk.rejected, fail)

      .addCase(materialStockPriceThunk.pending, pend)
      .addCase(materialStockPriceThunk.fulfilled, ok)
      .addCase(materialStockPriceThunk.rejected, fail)

      .addCase(deliveryComplianceThunk.pending, pend)
      .addCase(deliveryComplianceThunk.fulfilled, ok)
      .addCase(deliveryComplianceThunk.rejected, fail)

      .addCase(operationTimeThunk.pending, pend)
      .addCase(operationTimeThunk.fulfilled, ok)
      .addCase(operationTimeThunk.rejected, fail);
  },
});

export const kpiActions = kpiSlice.actions;
export default kpiSlice.reducer;
